import { PageProps } from '@/types';
import { AppSetting } from '@/types/models/app-setting';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

export const useFeatures = () => {
  const page = usePage<PageProps<{ app_settings: AppSetting }>>();
  const features = computed(() => page.props.app_settings.features);

  const isEnabled = (code: string) => {
    return features.value?.hasOwnProperty(code) && features.value[code];
  };

  return { isEnabled };
};
